import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { sessionStore } from '@/shared/auth/session-store';

/** 로그인이 필요한 화면들의 레이아웃 라우트 ID (src/routes/_app/_auth.tsx) */
const AUTH_ROUTE_ID = '/_app/_auth';

/**
 * 세션이 끝나면(로그아웃·다른 탭 로그아웃·토큰 갱신 실패·계정 제한) 화면을 옮긴다 — 이동은 여기서만 한다.
 *
 * 충전 화면(/)처럼 로그인 없이 볼 수 있는 화면에서는 그대로 두고(헤더만 로그인 전 상태로 바뀐다),
 * 로그인이 필요한 화면에서만 옮긴다. 직접 로그아웃했으면 홈으로, 그 밖의 이유면 돌아올 경로를 담아 로그인으로.
 * 화면 컴포넌트의 effect 로 처리하면 이동 중에 바뀐 위치(/login?...)를 다시 redirect 로 담아
 * 주소가 끝없이 중첩되므로, 세션 변화만 구독한다. 로더가 도는 동안 세션이 끝났을 수도 있어 마운트할 때도 확인한다.
 */
export function SessionWatcher() {
  const router = useRouter();

  useEffect(() => {
    const redirectIfEnded = (): void => {
      if (sessionStore.get()) return;
      const isAuthPage = router.state.matches.some(match => match.routeId === AUTH_ROUTE_ID);
      if (!isAuthPage) return;
      if (sessionStore.peekEndReason() === 'logout') {
        void router.navigate({ to: '/', replace: true });
        return;
      }
      void router.navigate({
        to: '/login',
        search: { redirect: router.latestLocation.href },
        replace: true,
      });
    };
    redirectIfEnded();
    return sessionStore.subscribe(redirectIfEnded);
  }, [router]);

  return null;
}
